import { defineStore } from 'pinia';
import { getAllUsers,getUserDetailInfo,registerUserInfo,getUserInfoByAdmin,updateUserInfoByAdmin,deleteUser, getUserByEmailToken, updateUserInfo, getUserDetailInfoForTrans, updateUserInfoForTrans } from '@/services';
import type { UserRegistrationInfo } from '@/views/AccountInfoRegister/const';
import type { TransAccountInfo } from '@/views/TransAccountInfo/const';

export interface UsersResponse {
  userId:number;
  email: string;
  userName: string;
  companyName: string;
  createdAt: Date;
  lastLogin: Date;
  roles:[];
}

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    users: [] as UsersResponse[],
    userInfo: {} as UserRegistrationInfo,
    transUserInfo: {} as TransAccountInfo,
    userLogin:{} as any,
    storedKeyWord :'',
  }),
  getters: {
    allUsers: (state) => state.users,
    currentUserInfo: (state) => state.userInfo,
  },
  actions: {
    async getUsers(keyWord: string) {
      const allUsers = await getAllUsers(keyWord);
      this.users = allUsers as UsersResponse[];
    },
    async getUserInfo() {
      const userInfo = await getUserDetailInfo();
      this.userInfo = userInfo as UserRegistrationInfo;
    },

    async getUserInfoForTrans() {
      const userInfo = await getUserDetailInfoForTrans();
      this.transUserInfo = userInfo as TransAccountInfo;
    },
    async getUserInfoByAdmin(userId:number) {
      const userInfo = await getUserInfoByAdmin(userId);
      this.userInfo = userInfo as UserRegistrationInfo;
    },
    async getUserInfoByAdminForTrans(userId:number) {
      const userInfo = await getUserInfoByAdmin(userId);
      this.transUserInfo = userInfo as TransAccountInfo;
    },
    async updateUserInfo(userData:UserRegistrationInfo){
      await updateUserInfo(userData);
    },
    async updateUserInfoForTrans(userData:TransAccountInfo){
      await updateUserInfoForTrans(userData);
    },
    async updateUserInfoByAdmin(userData:UserRegistrationInfo,userId:number){
      await updateUserInfoByAdmin(userData,userId);
    },
    async registerUserInfo(userData:UserRegistrationInfo,userId:number){
       return await registerUserInfo(userData,userId);
    },
    async deleteUser(userId:number) {
      await deleteUser(userId);
    },
    async getUserByEmailToken(emailToken:string){
      const user = await getUserByEmailToken(emailToken);
      this.userLogin = user;
    },
  }
});
